/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  AgreementsResponse,
  Error,
  GetAccountResponse,
  MeterResponse,
  ReferralDetailsResponse,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get agreements for account
 */
export const getAgreements = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<AgreementsResponse[]>(
    { url: `/api/v1/accounts/${accountId}/agreements`, method: "GET", signal },
    options,
  )
}

export const getGetAgreementsQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "agreements"] as const
}

export const useGetAgreementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgreements>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgreements>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetAgreementsQueryKey(accountId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgreements>>> = ({
    signal,
  }) => getAgreements(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getAgreements>>,
    TError,
    TData
  >
}

export type GetAgreementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgreements>>
>
export type GetAgreementsQueryError = ErrorType<Error>

/**
 * @summary Get agreements for account
 */

export function useGetAgreements<
  TData = Awaited<ReturnType<typeof getAgreements>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgreements>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetAgreementsQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get Refer A friend details for an account
 */
export const referAFriendDetail = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<ReferralDetailsResponse>(
    {
      url: `/api/v1/accounts/${accountId}/referAFriendDetail`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getReferAFriendDetailQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "referAFriendDetail"] as const
}

export const useReferAFriendDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof referAFriendDetail>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof referAFriendDetail>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getReferAFriendDetailQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof referAFriendDetail>>
  > = ({ signal }) => referAFriendDetail(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof referAFriendDetail>>,
    TError,
    TData
  >
}

export type ReferAFriendDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof referAFriendDetail>>
>
export type ReferAFriendDetailQueryError = ErrorType<Error>

/**
 * @summary Get Refer A friend details for an account
 */

export function useReferAFriendDetail<
  TData = Awaited<ReturnType<typeof referAFriendDetail>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof referAFriendDetail>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useReferAFriendDetailQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get account information
 */
export const getAccount = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<GetAccountResponse>(
    { url: `/api/v1/accounts/${accountId}`, method: "GET", signal },
    options,
  )
}

export const getGetAccountQueryKey = (accountId: MaybeRefOrGetter<number>) => {
  return ["api", "v1", "accounts", accountId] as const
}

export const useGetAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetAccountQueryKey(accountId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({
    signal,
  }) => getAccount(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getAccount>>,
    TError,
    TData
  >
}

export type GetAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccount>>
>
export type GetAccountQueryError = ErrorType<Error>

/**
 * @summary Get account information
 */

export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetAccountQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Retrieve list of meters for given account
 */
export const getMetersByBillingAccountId = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<MeterResponse[]>(
    { url: `/api/v1/accounts/${accountId}/meters`, method: "GET", signal },
    options,
  )
}

export const getGetMetersByBillingAccountIdQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "meters"] as const
}

export const useGetMetersByBillingAccountIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMetersByBillingAccountId>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMetersByBillingAccountId>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetMetersByBillingAccountIdQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMetersByBillingAccountId>>
  > = ({ signal }) =>
    getMetersByBillingAccountId(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getMetersByBillingAccountId>>,
    TError,
    TData
  >
}

export type GetMetersByBillingAccountIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMetersByBillingAccountId>>
>
export type GetMetersByBillingAccountIdQueryError = ErrorType<Error>

/**
 * @summary Retrieve list of meters for given account
 */

export function useGetMetersByBillingAccountId<
  TData = Awaited<ReturnType<typeof getMetersByBillingAccountId>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMetersByBillingAccountId>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetMetersByBillingAccountIdQueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
